import enviro from 'enviro';
import { useEffect, useState } from 'react';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { NEXT_STEPS_SURVEY_API_NAMES } from 'ui-addon-upgrades/_core/common/constants/trials';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getFeatureWithRPC } from '../../common/api/featuresApi';
import { isProApiName } from '../SurveyResponses';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
import FeatureSurveyModal from './featureSurvey/FeatureSurveyModal';
import { jsx as _jsx } from "react/jsx-runtime";
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY',
  FEATURE_SURVEY: 'FEATURE_SURVEY'
};
const TrialActivationSuccessContainer = ({
  hideBackground,
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  shouldHideSurvey,
  showTrialLoadingState,
  showSuccessModalIllustration
}) => {
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  const {
    upgradeProduct,
    apiName
  } = upgradeData;
  const apiNameToUse = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const isEligibleForFeatureSurvey = isProApiName(apiNameToUse);
  const shouldShowTrialFeatureSurvey = enviro.isProd() ? isEligibleForFeatureSurvey : isEligibleForFeatureSurvey || window.location.search.includes('showFeatureSurvey');
  const initialModal = shouldShowTrialFeatureSurvey ? SUCCESS_MODAL_TYPES.FEATURE_SURVEY : SUCCESS_MODAL_TYPES.INITIAL_SUCCESS;
  const [successModalType, setSuccessModalType] = useState(initialModal);
  const maybeShowNextStepsSurvey = () => {
    const nextStepsIncludesProduct = NEXT_STEPS_SURVEY_API_NAMES.includes(apiNameToUse);
    const shouldShowNextStepsSurvey = nextStepsIncludesProduct && !shouldHideSurvey;
    if (shouldShowNextStepsSurvey) {
      setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
    } else if (onSuccess) {
      onSuccess();
    }
  };
  useEffect(() => {
    if (upgradeData.feature) {
      getFeatureWithRPC({
        shortName: upgradeData.feature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(error => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
        console.error(error);
      });
    }
    setFeatureData({
      feature: undefined,
      fetched: true
    });
  }, [upgradeData]);
  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return /*#__PURE__*/_jsx(TrialActivationNextStepsModal, {
        upgradeData: upgradeData
      });
    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return /*#__PURE__*/_jsx(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: header,
        subText: subText,
        ctaText: ctaText,
        showSuccessModalIllustration: showSuccessModalIllustration,
        showTrialLoadingState: showTrialLoadingState && !featureData.fetched,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData,
        featureData: featureData.feature
      });
    case SUCCESS_MODAL_TYPES.FEATURE_SURVEY:
      return /*#__PURE__*/_jsx(FeatureSurveyModal, {
        apiName: apiNameToUse,
        setInitialSuccessModal: () => {
          setSuccessModalType(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
        },
        upgradeData: upgradeData
      });
    default:
      return null;
  }
};
export default TrialActivationSuccessContainer;